import './Checkout.css';
import { useCart } from "../../Context/CartContext";
import React, { useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import axios from 'axios';
import Navbar from '../../Components/NavBar/NavBar';
import Operation from '../../Components/Operation/Operation';
import Footer from '../../Components/Foooter/Footer';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';
import PropagateLoader from "react-spinners/HashLoader";

const CheckoutPage = () => {
  const { cartItems, removeFromCart, getTotalPrice } = useCart();
  
  // Step management
  const [currentStep, setCurrentStep] = useState(1);
  
  // Delivery details
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState({
    fullName: '',
    street: '',
    city: '',
    province: '',
    postalCode: '',
    additionalInfo: ''
  });
  
  // Payment details
  const [phone, setPhone] = useState('');
  const [operator, setOperator] = useState('airtel');
  
  // Payment status
  const [loading, setLoading] = useState(false);
  const [reference, setReference] = useState('');
  const [status, setStatus] = useState(null);
  const [paymentInitiated, setPaymentInitiated] = useState(false);

  const handleRemoveItem = (id, color, size) => {
    removeFromCart(id, color, size);
  };

  const handleDeliveryAddressChange = (field, value) => {
    setDeliveryAddress(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const isDeliveryDetailsComplete = () => {
    if (deliveryMethod === 'pickup') return true;
    if (deliveryMethod === 'delivery') {
      return deliveryAddress.fullName && 
             deliveryAddress.street && 
             deliveryAddress.city && 
             deliveryAddress.province;
    }
    return false;
  };

  const handlePayment = async () => {
    setLoading(true);

    const cartItemDetails = cartItems.map(item => ({
      name: item.title,
      price: item.price,
      color: item.color,
      size: item.size,
      quantity: item.quantity,
      totalCost: item.price * item.quantity,
    }));

    const paymentData = {
      amount: getTotalPrice(),
      phone_number: phone,
      operator,
      items: cartItemDetails,
      delivery_method: deliveryMethod,
      delivery_address: deliveryMethod === 'delivery' ? deliveryAddress : null
    };

    try {
      const response = await axios.post("https://albeutystore.store/payment", paymentData);
      //const response = await axios.post("https://lencopay.onrender.com/payment", paymentData);
      setReference(response.data.data.reference);
      setPaymentInitiated(true);
      setLoading(false);
      alert("Payment initiated! Please check your phone for the OTP prompt.");
    } catch (error) {
      setLoading(false);
      console.error("Payment error:", error);
      alert("Payment failed. Please try again.");
    }
  };

  const checkStatus = async () => {
    if (!reference) {
      alert("No reference found. Please initiate payment first.");
      return;
    }

    try {
      const response = await axios.get(`https://albeutystore.store/collections/status/${reference}`);
      //const response = await axios.get(`https://lencopay.onrender.com/collections/status/${reference}`);
      setStatus(response.data);
    } catch (error) {
      console.error("Status check error:", error);
      alert("Failed to check status.");
    }
  };

  const goToNextStep = () => {
    if (currentStep === 1 && cartItems.length > 0) {
      setCurrentStep(2);
    } else if (currentStep === 2 && isDeliveryDetailsComplete()) {
      setCurrentStep(3);
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setPaymentInitiated(false);
    }
  };

  return (
    <>    
      <div className='topnav'>
        <Navbar/>
        <ScrollToTop/>
      </div>

      <div className="checkout-container">
        {/* Progress Steps */}
        <div className="checkout-progress">
          <div className={`progress-step ${currentStep >= 1 ? 'active' : ''}`}>
            <div className="step-number">1</div>
            <div className="step-label">Cart Review</div>
          </div>
          <div className={`progress-line ${currentStep >= 2 ? 'active' : ''}`}></div>
          <div className={`progress-step ${currentStep >= 2 ? 'active' : ''}`}>
            <div className="step-number">2</div>
            <div className="step-label">Delivery</div>
          </div>
          <div className={`progress-line ${currentStep >= 3 ? 'active' : ''}`}></div>
          <div className={`progress-step ${currentStep >= 3 ? 'active' : ''}`}>
            <div className="step-number">3</div>
            <div className="step-label">Payment</div>
          </div>
        </div>

        {/* Step 1: Cart Review */}
        {currentStep === 1 && (
          <div className="checkout-step">
            <h1>Review Your Order</h1>
            
            <div className="cart-items">
              {cartItems.length === 0 ? (
                <div className="empty-cart">
                  <p>Your cart is empty.</p>
                </div>
              ) : (
                <ul>
                  {cartItems.map(item => (
                    // console.log("item",item),
                    <li key={`${item.id}-${item.color}-${item.size}`} className="cart-item">
                      <div className="item-details">
                        <h2>{item?.title}</h2>
                        <div className="item-info">
                          <p><span className="label">Price:</span> ZMK {item.price}</p>
                          <p><span className="label">Quantity:</span> {item.quantity}</p>
                          <p><span className="label">Size:</span> {item.size}</p>
                          <p className="color-info">
                            <span className="label">Color:</span>
                            <span className="color-box" style={{ backgroundColor: item.color }}></span>
                            {item.colorName}
                          </p>
                          <p className="item-total"><span className="label">Subtotal:</span> ZMK {item.price * item.quantity}</p>
                        </div>
                      </div>
                      <button 
                        className="remove-btn" 
                        onClick={() => handleRemoveItem(item.id, item.color, item.size)}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="order-summary">
              <h2>Order Summary</h2>
              <div className="summary-row">
                <span>Total Items:</span>
                <span>{cartItems.reduce((sum, item) => sum + item.quantity, 0)}</span>
              </div>
              <div className="summary-row total">
                <span>Total Amount:</span>
                <span>ZMK {getTotalPrice()}</span>
              </div>
            </div>

            <div className="step-actions">
              <button 
                className="btn btn-primary"
                onClick={goToNextStep}
                disabled={cartItems.length === 0}
              >
                Continue to Delivery
              </button>
            </div>
          </div>
        )}

        {/* Step 2: Delivery Details */}
        {currentStep === 2 && (
          <div className="checkout-step">
            <h1>Delivery Information</h1>

            <div className="delivery-method-section">
              <h2>How would you like to receive your order?</h2>
              
              <div className="delivery-options">
                <label className={`delivery-option ${deliveryMethod === 'pickup' ? 'selected' : ''}`}>
                  <input 
                    type="radio" 
                    name="delivery" 
                    value="pickup"
                    checked={deliveryMethod === 'pickup'}
                    onChange={(e) => setDeliveryMethod(e.target.value)}
                  />
                  <div className="option-content">
                    <h3>Pickup from Our Location</h3>
                    <p>Collect your order from one of our stores</p>
                  </div>
                </label>

                <label className={`delivery-option ${deliveryMethod === 'delivery' ? 'selected' : ''}`}>
                  <input 
                    type="radio" 
                    name="delivery" 
                    value="delivery"
                    checked={deliveryMethod === 'delivery'}
                    onChange={(e) => setDeliveryMethod(e.target.value)}
                  />
                  <div className="option-content">
                    <h3>Home Delivery</h3>
                    <p>We'll deliver to your address</p>
                  </div>
                </label>
              </div>
            </div>

            {deliveryMethod === 'delivery' && (
              <div className="delivery-form">
                <h2>Delivery Address</h2>
                
                <div className="form-group">
                  <label>Full Name *</label>
                  <input 
                    type="text"
                    value={deliveryAddress.fullName}
                    onChange={(e) => handleDeliveryAddressChange('fullName', e.target.value)}
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="form-group">
                  <label>Street Address *</label>
                  <input 
                    type="text"
                    value={deliveryAddress.street}
                    onChange={(e) => handleDeliveryAddressChange('street', e.target.value)}
                    placeholder="House number and street name"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>City *</label>
                    <input 
                      type="text"
                      value={deliveryAddress.city}
                      onChange={(e) => handleDeliveryAddressChange('city', e.target.value)}
                      placeholder="City"
                    />
                  </div>

                  <div className="form-group">
                    <label>Province *</label>
                    <input 
                      type="text"
                      value={deliveryAddress.province}
                      onChange={(e) => handleDeliveryAddressChange('province', e.target.value)}
                      placeholder="Province"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Postal Code</label>
                  <input 
                    type="text"
                    value={deliveryAddress.postalCode}
                    onChange={(e) => handleDeliveryAddressChange('postalCode', e.target.value)}
                    placeholder="Postal code (optional)"
                  />
                </div>

                <div className="form-group">
                  <label>Additional Information</label>
                  <textarea 
                    value={deliveryAddress.additionalInfo}
                    onChange={(e) => handleDeliveryAddressChange('additionalInfo', e.target.value)}
                    placeholder="Apartment, suite, landmark, etc."
                    rows="3"
                  />
                </div>
              </div>
            )}

            <div className="step-actions">
              <button className="btn btn-secondary" onClick={goToPreviousStep}>
                Back to Cart
              </button>
              <button 
                className="btn btn-primary"
                onClick={goToNextStep}
                disabled={!isDeliveryDetailsComplete()}
              >
                Continue to Payment
              </button>
            </div>
          </div>
        )}

        {/* Step 3: Payment */}
        {currentStep === 3 && (
          <div className="checkout-step">
            <h1>Payment</h1>

            {!paymentInitiated ? (
              <>
                <div className="payment-form">
                  <div className="form-group">
                    <label>Select Operator *</label>
                    <select 
                      value={operator} 
                      onChange={(e) => setOperator(e.target.value)} 
                      className="operator-select"
                    >
                      <option value="airtel">Airtel Money</option>
                      <option value="mtn">MTN Mobile Money</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Phone Number *</label>
                    <PhoneInput
                      country={'zm'}
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      inputStyle={{
                        width: '100%',
                        padding: '12px 12px 12px 50px',
                        height: '48px',
                        fontSize: '16px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                      }}
                    />
                  </div>

                  <div className="payment-summary-box">
                    <h3>Payment Summary</h3>
                    <div className="summary-detail">
                      <span>Total Amount:</span>
                      <span className="amount">ZMK {getTotalPrice()}</span>
                    </div>
                  </div>
                </div>

                <div className="step-actions">
                  <button className="btn btn-secondary" onClick={goToPreviousStep}>
                    Back to Delivery
                  </button>
                  <button 
                    className="btn btn-primary btn-pay"
                    onClick={handlePayment}
                    disabled={!phone || !operator || loading}
                  >
                    {loading ? (
                      <PropagateLoader size={10} color="#fff" />
                    ) : (
                      `Pay ZMK ${getTotalPrice()}`
                    )}
                  </button>
                </div>
              </>
            ) : (
              <div className="payment-initiated">
                <div className="reference-card">
                  <div className="reference-icon">✓</div>
                  <h2>Payment Request Sent!</h2>
                  <p className="instruction">Please check your phone for the OTP prompt and complete the payment.</p>
                  
                  <div className="reference-display">
                    <label>Transaction Reference</label>
                    <div className="reference-number">{reference}</div>
                    <p className="reference-note">Save this reference number for tracking</p>
                  </div>

                  <button className="btn btn-primary" onClick={checkStatus}>
                    Check Payment Status
                  </button>

                  {status && (
                    <div className={`status-card ${status.data.status.toLowerCase()}`}>
                      <h3>Payment Status: {status.data.status}</h3>
                      <div className="status-details">
                        <p><span>Message:</span> {status.message}</p>
                        <p><span>Amount:</span> ZMK {status.data.amount}</p>
                        <p><span>Reference:</span> {status.data.reference}</p>
                      </div>
                    </div>
                  )}

                  <button className="btn btn-link" onClick={() => {
                    setPaymentInitiated(false);
                    setReference('');
                    setStatus(null);
                  }}>
                    Try Different Payment Method
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <Operation/>
      <Footer/>
    </>
  );
};

export default CheckoutPage;

// import './Checkout.css'; // Import your custom CSS for styling
// import { useCart } from "../../Context/CartContext";
// import React, { useState } from 'react';
// import 'react-phone-input-2/lib/style.css';
// import PhoneInput from 'react-phone-input-2';
// import { getAuthToken, createPaymentRequest, getPaymentStatus } from './ApiUtils';
// import axios from 'axios'
// import Navbar from '../../Components/NavBar/NavBar'
// import Operation from '../../Components/Operation/Operation';
// import Footer from '../../Components/Foooter/Footer';
// import scrolltop from '../../Components/Scrolltop/Scrolltop'
// import ScrollToTop from '../../Components/Scrolltop/Scrolltop';
// import PropagateLoader  from "react-spinners/HashLoader";


// const CheckoutPage = () => {
//   const { cartItems, removeFromCart, getTotalPrice } = useCart();
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const [paymentId, setPaymentId] = useState(null);
//   const [phone, setPhone] = useState('');

//     const [amount, setAmount] = useState("");
//     const [operator, setOperator] = useState("airtel");
//     const [reference, setReference] = useState("");
//     const [status, setStatus] = useState(null);

//   const handlePhoneNumberChange = (e) => {
//     setPhoneNumber(e.target.value);
//   };

//   // const handleRemoveItem = (itemId) => {
//   //   console.log("in remove",itemId)
//   //   removeFromCart(itemId);
//   // };
//   const handleRemoveItem = (id, color, size) => {
//     removeFromCart(id, color, size);
//   };
  
//   const handlePayment = async () => {
//     setLoading(true)

//     const cartItemDetails = cartItems.map(item => ({
//       name: item.title,
//       price: item.price,
//       color: item.color,
//       size: item.size,
//       quantity: item.quantity,
//       totalCost: item.price * item.quantity,
//     }));

//     console.log(cartItemDetails)
// // sgd
//     if(cartItemDetails)

//     try {
//         const response = await axios.post("https://lencopay.onrender.com/payment", {
//         //const response = await axios.post("http://localhost:2002/payment", {
//             amount : getTotalPrice(),
//             phone_number: phone,
//             operator,
//             items: cartItemDetails,  // Send cart items along with payment details
//         });
//         console.log("response",response)
//         setReference(response.data.data.reference);
        
//         alert("Payment initiated, please check the status.");
//         setLoading(false)
//     } catch (error) {
//       setLoading(false)
//         console.error("Payment error:", error);
//         alert("Payment failed.");
//     }
// };

// const checkStatus = async () => {
//     if (!reference) {
//         alert("No reference found, please initiate payment first.");
//         return;
//     }

//     try {
//         const response = await axios.get(`https://lencopay.onrender.com/collections/status/${reference}`);
//         setStatus(response.data);
//     } catch (error) {
//         console.error("Status check error:", error);
//         alert("Failed to check status.");
//     }
// };


//   // const handlePayment = async () => {
//   //   if (!phoneNumber) {
//   //     setError('Please enter your phone number.');
//   //     return;
//   //   }
//   //   setLoading(true);
//   //   setError(null); // Clear previous errors
//   //   try {
//   //     const token = await getAuthToken();
//   //     const paymentData = {
//   //       description: 'Payment for Cart Items',
//   //       customerFirstName: 'John',
//   //       customerLastName: 'Doe',
//   //       email: 'john.doe@example.com',
//   //       phoneNumber: phoneNumber,
//   //       amount: getTotalPrice(),
//   //     };
//   //     const payment = await createPaymentRequest(token, paymentData);
//   //     setPaymentId(payment.id);
//   //     checkPaymentStatus(token, payment.id);
//   //   } catch (error) {
//   //     console.error('Error handling payment:', error);
//   //     setError('Failed to process payment. Please try again later.');
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const checkPaymentStatus = async (token, paymentId) => {
//     try {
//       const interval = setInterval(async () => {
//         const status = await getPaymentStatus(token, paymentId);
//         setPaymentStatus(status);
//         if (status.status === 'SUCCESS' || status.status === 'FAILED') {
//           clearInterval(interval);
//         }
//       }, 5000); // Check every 5 seconds
//     } catch (error) {
//       console.error('Error checking payment status:', error);
//       setError('Failed to check payment status. Please try again later.');
//     }
//   };

//   return (
//       <>    
//  <div className='topnav'>
//    <Navbar/>
//    <ScrollToTop/>
  
//  </div>
// <div className="checkout-container">
    
//     <h1>Checkout</h1>
//     {/* <div className="cart-items">
//       {cartItems.length === 0 ? (
//         <p>Your cart is empty.</p>
//       ) : (
//         <ul>
//           {cartItems.map(item => (
//             <li key={item.id} className="cart-item">
//               <div>
//                 <h2>{item.title}</h2>
//                 <p>Price: ZMK {item.totalPrice}</p>
//                 <button onClick={() => handleRemoveItem(item.id)}>Remove</button>
//               </div>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div> */}
//     <div className="cart-items">
//     <div className="cart-items">
//   {cartItems.length === 0 ? (
//     <p>Your cart is empty.</p>
//   ) : (
//     <ul>
//       {cartItems.map(item => (
//         <li key={item.id} className="cart-item">
//           <div>
//             <h2>{item.title}</h2>
//             <p>Price per item: ZMK {item.price}</p>
//             <p>Quantity: {item.quantity}</p>
//             <p>Size: {item.size}</p> {/* Display item size */}
//             <p>Color: <span className="color-box" style={{ backgroundColor: item.color }}></span> {item.colorName}</p> {/* Display color name and a color box */}
//             <p>Total for this item: ZMK {item.price * item.quantity}</p>
//             {/* <button onClick={() => handleRemoveItem(item.id)}>Remove</button> */}
//             <button onClick={() => handleRemoveItem(item.id, item.color, item.size)}>Remove</button>

//           </div>
//         </li>
//       ))}
//     </ul>
//   )}
// </div>

//   {/* {cartItems.length === 0 ? (
//     <p>Your cart is empty.</p>
//   ) : (
//     <ul>
//       {cartItems.map(item => (
//         <li key={item.id} className="cart-item">
//           <div>
//             <h2>{item.title}</h2>
//             <p>Price per item: ZMK {item.price}</p>
//             <p>Quantity: {item.quantity}</p>
//             <p>Total for this item: ZMK {item.price * item.quantity}</p>
//             <button onClick={() => handleRemoveItem(item.id)}>Remove</button>
//           </div>
//         </li>
//       ))}
//     </ul>
//   )} */}
// </div>
//     <div className="summary-container">
//       <h2>Payment Summary</h2>
//       <p><strong>Total Amount:</strong> ZMK {getTotalPrice()}</p>
//     </div>
//      <div className="payment-section">
//       <label>Operator</label>
//       <select 
//         value={operator} 
//         onChange={(e) => setOperator(e.target.value)} 
//         className="operator-select"
//       >
//         <option value="airtel">Airtel</option>
//         <option value="mtn">MTN</option>
//       </select>
      
//       <label>Phone Number</label>
//       <PhoneInput
//         country={'zm'}
//         value={phone}
//         onChange={(phone) => setPhone(phone)}
//         // inputStyle={{ width: '100%', padding: '8px', marginBottom: '10px' }}
//         inputStyle={{
//           width: '100%',
//           padding: '8px 8px 8px 50px', // Adjusted padding to make room for the flag and prefix
//           marginBottom: '10px',
//           height: '40px', // Ensure the input height matches the overall design
//           fontSize: '16px',
//         }}
//       />
      
//       {/* <label>Amount</label>
//       <input 
//         type="number" 
//         value={amount} 
//         onChange={(e) => setAmount(e.target.value)} 
//         placeholder="Enter amount"
//       /> */}
      
//       <button 
//         onClick={handlePayment}
//         disabled={ !phone || !operator || cartItems.length === 0}
//         //disabled={!amount || !phone || !operator}
//       > 
//        {loading ? <PropagateLoader size={30} />:
//          <p>Make Payment</p> }
//       </button>
//     </div>
//      {/* New status check button */}
//      <div className="status-check-section">
//               <button onClick={checkStatus}>Check Payment Status</button>
//               {status && (
//                   <div className="status-info">
//                       <h3>Status: {status.data.status}</h3>
//                       <p>Message: {status.message}</p>
//                       <p>Amount: {status.data.amount}</p>
//                       <p>Reference: {status.data.reference}</p>
//                   </div>
//               )}
//           </div>
  
//   </div>

//    <Operation/>
//    <Footer/>
      
//       </>

//   );
// };

// export default CheckoutPage;

//comment 3
// import './Checkout.css'; // Import your custom CSS for styling
// import { useCart } from "../../Context/CartContext";
// import React, { useContext, useEffect, useState } from 'react';
//  import { getAuthToken, createPaymentRequest, getPaymentStatus } from './ApiUtils';



// const CheckoutPage = () => {
//   const { cartItems, removeFromCart } = useCart();
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const [paymentId, setPaymentId] = useState(null);

//   const handlePhoneNumberChange = (e) => {
//     setPhoneNumber(e.target.value);
//   };

//   const handleRemoveItem = (itemId) => {
//     removeFromCart(itemId);
//   };

//   const handlePayment = async () => {
//     if (!phoneNumber) {
//       setError('Please enter your phone number.');
//       return;
//     }
//     setLoading(true);
//     setError(null); // Clear previous errors
//     try {
//       const token = await getAuthToken();
//       const totalAmount = cartItems.reduce((acc, item) => acc + item.price, 0);
//       const paymentData = {
//         description: 'Payment for Cart Items',
//         customerFirstName: 'John',
//         customerLastName: 'Doe',
//         email: 'john.doe@example.com',
//         phoneNumber: phoneNumber,
//         amount: totalAmount,
//       };
//       const payment = await createPaymentRequest(token, paymentData);
//       setPaymentId(payment.id);
//       checkPaymentStatus(token, payment.id);
//     } catch (error) {
//       console.error('Error handling payment:', error);
//       setError('Failed to process payment. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async (token, paymentId) => {
//     try {
//       const interval = setInterval(async () => {
//         const status = await getPaymentStatus(token, paymentId);
//         setPaymentStatus(status);
//         if (status.status === 'SUCCESS' || status.status === 'FAILED') {
//           clearInterval(interval);
//         }
//       }, 5000); // Check every 5 seconds
//     } catch (error) {
//       console.error('Error checking payment status:', error);
//       setError('Failed to check payment status. Please try again later.');
//     }
//   };

//   const totalAmount = cartItems.reduce((acc, item) => acc + item.price, 0) / 100;

//   useEffect(()=>{
//   //  console.log("api",process.env.REACT_APP_SOFT_HOMES)
//   },[])

//   return (
//     <div className="checkout-container">
//       <h1>Checkout</h1>
//       <div className="cart-items">
//         {cartItems.length === 0 ? (
//           <p>Your cart is empty.</p>
//         ) : (
//           <ul>
//             {cartItems.map(item => (
//               <li key={item.id} className="cart-item">
//                 <div>
//                   <h2>{item.title}</h2>
//                   <p>Price: ${item.price / 100}</p>
//                   <button onClick={() => handleRemoveItem(item.id)}>Remove</button>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//       <div className="summary-container">
//         <h2>Payment Summary</h2>
//         <p><strong>Total Amount:</strong> ${totalAmount}</p>
//       </div>
//       <div className="payment-section">
//         <label htmlFor="phoneNumber">Phone Number:</label>
//         <input
//           type="text"
//           id="phoneNumber"
//           value={phoneNumber}
//           onChange={handlePhoneNumberChange}
//           placeholder="Enter your phone number"
//         />
//         <button onClick={handlePayment} disabled={loading || cartItems.length === 0}>
//           {loading ? 'Processing...' : 'Make Payment'}
//         </button>
//         {error && <p className="error-message">{error}</p>}
//         {paymentStatus && (
//           <div className="status-container">
//             <h2>Payment Status</h2>
//             <p><strong>ID:</strong> {paymentStatus.id}</p>
//             <p><strong>Amount:</strong> ${paymentStatus.amount / 100}</p>
//             <p><strong>Status:</strong> {paymentStatus.status}</p>
//             <p><strong>Message:</strong> {paymentStatus.message}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // // Mock functions for API calls
// // const getAuthToken = async () => {
// //   // Replace with actual token retrieval logic
// //   return 'your-auth-token';
// // };

// // const createPaymentRequest = async (token, paymentData) => {
// //   // Replace with actual payment request logic
// //   return { id: 'payment-id' };
// // };

// // const getPaymentStatus = async (token, paymentId) => {
// //   // Replace with actual payment status retrieval logic
// //   return { id: paymentId, amount: 10000, status: 'SUCCESS', message: 'Payment successful' };
// // };

// export default CheckoutPage;


// import React, { useState } from 'react';
// import './Checkout.css'; // Import the CSS file
// import { getAuthToken, createPaymentRequest, getPaymentStatus } from './ApiUtils';
// import { useCart } from '../../Context/CartContext';



// const PaymentComponent = () => {
//   const { cartItems } = useCart(); // Access cart items from context
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const [paymentId, setPaymentId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [phoneNumber, setPhoneNumber] = useState('');

//   const handlePayment = async () => {
//     if (!phoneNumber) {
//       setError('Please enter your phone number.');
//       return;
//     }
//     setLoading(true);
//     setError(null); // Clear previous errors
//     try {
//       const token = await getAuthToken();
//       const totalAmount = cartItems.reduce((acc, item) => acc + item.price, 0);
//       const paymentData = {
//         description: 'Payment for Cart Items',
//         customerFirstName: 'John',
//         customerLastName: 'Doe',
//         email: 'john.doe@example.com',
//         phoneNumber: phoneNumber,
//         amount: totalAmount,
//       };
//       const payment = await createPaymentRequest(token, paymentData);
//       setPaymentId(payment.id);
//       checkPaymentStatus(token, payment.id);
//     } catch (error) {
//       console.error('Error handling payment:', error);
//       setError('Failed to process payment. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkPaymentStatus = async (token, paymentId) => {
//     try {
//       const interval = setInterval(async () => {
//         const status = await getPaymentStatus(token, paymentId);
//         setPaymentStatus(status);
//         if (status.status === 'SUCCESS' || status.status === 'FAILED') {
//           clearInterval(interval);
//         }
//       }, 5000); // Check every 5 seconds
//     } catch (error) {
//       console.error('Error checking payment status:', error);
//       setError('Failed to check payment status. Please try again later.');
//     }
//   };

//   return (
//     <div className="container">
//       <div className="summary-container">
//         <h2>Payment Summary</h2>
//         {cartItems.length === 0 ? (
//           <p>No items in the cart.</p>
//         ) : (
//           <>
//             <ul className="item-list">
//               {cartItems.map((item) => (
//                 <li key={item.id}>
//                   <p><strong>{item.name}:</strong> ${item.price / 100}</p>
//                 </li>
//               ))}
//             </ul>
//             <p><strong>Total Amount:</strong> ${cartItems.reduce((acc, item) => acc + item.price, 0) / 100}</p>
//           </>
//         )}
//       </div>
//       <input
//         type="text"
//         className="input-field"
//         placeholder="Enter your billing phone number"
//         value={phoneNumber}
//         onChange={(e) => setPhoneNumber(e.target.value)}
//       />
//       <button className="button" onClick={handlePayment} disabled={loading || cartItems.length === 0}>
//         {loading ? 'Processing...' : 'Make Payment'}
//       </button>
//       {error && <p className="error-message">{error}</p>}
//       {paymentStatus && (
//         <div className="status-container">
//           <h2>Payment Status</h2>
//           <p><strong>ID:</strong> {paymentStatus.id}</p>
//           <p><strong>Amount:</strong> ${paymentStatus.amount / 100}</p>
//           <p><strong>Status:</strong> {paymentStatus.status}</p>
//           <p><strong>Message:</strong> {paymentStatus.message}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PaymentComponent;
